import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=1c3d4a39&scoped=true&"
import script from "./Customers.vue?vue&type=script&lang=js&"
export * from "./Customers.vue?vue&type=script&lang=js&"
import style0 from "./Customers.vue?vue&type=style&index=0&id=1c3d4a39&prod&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&id=1c3d4a39&prod&scoped=true&lang=css&"
import style2 from "./Customers.vue?vue&type=style&index=2&id=1c3d4a39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3d4a39",
  null
  
)

export default component.exports